import { FlowStatus } from "@/interfaces/flow";
import { httpClient } from "@/lib/api";
import { Edge, Node } from "@xyflow/react";

export interface FlowResponse {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  name: string;
  description: string;
  workflow: Workflow;
  teamId: number;
  runCount: number;
  finishedCount: number;
  status: FlowStatus;
  sendMessageCount: number;
  lastRun: Date | null;
  conversionRate: number;
}

export interface Workflow {
  edges: Edge[];
  nodes: Node[];
}


type ListFlowResponse = FlowResponse[];

type CreateFlowPayload = {
  name: string;
  description?: string;
}

export class FlowService {
  public static async create(payload: CreateFlowPayload) {
    const { data } = await httpClient().post<FlowResponse>('/flows', payload);
    return data;
  }

  public static async list() {
    const { data } = await httpClient().get<ListFlowResponse>(`/flows`);
    return data;
  }

  public static async get(id: number) {
    const { data } = await httpClient().get<FlowResponse>(`/flows/${id}`);
    return data;
  }

  public static async update(id: number, payload: Partial<FlowResponse>) {
    const { data } = await httpClient().patch<FlowResponse>(`/flows/${id}`, payload);
    return data;
  }

  public static async delete(id: number) {
    const { data } = await httpClient().delete<FlowResponse>(`/flows/${id}`);
    return data;
  }
}
